'use client'

import { cn } from 'cn'
import { OTPInput, OTPInputContext } from 'input-otp'
import * as React from 'react'

function InputOTP({ className, containerClassName, ...props }: React.ComponentProps<typeof OTPInput> & { containerClassName?: string }) {
	return (
		<OTPInput
			data-slot="input-otp"
			containerClassName={cn('flex w-full items-center has-disabled:opacity-50', containerClassName)}
			spellCheck={false}
			className={cn('w-full text-center disabled:cursor-not-allowed', className)}
			{...props}
		/>
	)
}

function InputOTPGroup({ className, ...props }: React.ComponentProps<'div'>) {
	return <div data-slot="input-otp-group" className={cn('grid w-full grid-cols-6 gap-2', className)} {...props} />
}

function InputOTPSlot({ index, className, ...props }: React.ComponentProps<'div'> & { index: number }) {
	const inputOTPContext = React.useContext(OTPInputContext)
	const { char, hasFakeCaret, isActive } = inputOTPContext?.slots?.[index] ?? {}

	return (
		<div
			data-slot="input-otp-slot"
			data-active={isActive}
			className={cn(
				'relative flex aspect-square min-w-0 items-center justify-center rounded-md border border-input text-base transition-[color,box-shadow] outline-none',
				'aria-invalid:border-fault data-[active=true]:z-10 data-[active=true]:border-ring data-[active=true]:ring-3 data-[active=true]:ring-ring/40 data-[active=true]:aria-invalid:border-fault',
				className,
			)}
			{...props}
		>
			{char}
			{hasFakeCaret && (
				<div className="pointer-events-none absolute inset-0 flex items-center justify-center">
					<div className="h-5 w-px animate-caret-blink bg-foreground duration-1000" />
				</div>
			)}
		</div>
	)
}

export { InputOTP, InputOTPGroup, InputOTPSlot }
